import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tabs: [], // Array of open tab objects. e.g., { id, title, path, componentKey }
  activeTabId: null, // The unique ID of the currently visible tab
};

export const workspaceSlice = createSlice({
  name: "workspace",
  initialState,
  reducers: {
    setTabs(state, { payload }) {
      state.tabs = payload;
    },
    setActiveTab(state, { payload }) {
      state.activeTabId = payload;
    },
  },
});

// Export actions for components to use
export const { setActiveTab, setTabs } = workspaceSlice.actions;

// Export the reducer to be added to the store
export default workspaceSlice.reducer;

// Selector for easy access to the workspace state
export const selectWorkspace = (state) => state.workspace;
